import React, { useId, useRef, useState } from 'react'
import Tab from '@mui/material/Tab'
import Popover from '@mui/material/Popover'
import {
    CUSTOM_DATE_END_DATE_ROUTE_PARAM,
    CUSTOM_DATE_START_DATE_ROUTE_PARAM,
    TradeGraphCustomDatesForm,
} from './CustomDatesForm'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth'
import { useQuery } from '../../../../hooks/useQuery'

export const TradesGraphCustomDatesButton = ({
    firstTradingDate,
    isSelected,
    lastTradingDate,
}: {
    firstTradingDate: number
    isSelected: boolean
    lastTradingDate: number
}) => {
    const popoverId = useId()
    const anchorEl = useRef<HTMLDivElement | null>(null)
    const query = useQuery()
    const [isOpen, setIsOpen] = useState(false)
    const startDate = query.get(CUSTOM_DATE_START_DATE_ROUTE_PARAM)
    const endDate = query.get(CUSTOM_DATE_END_DATE_ROUTE_PARAM)

    const handleToggleOpen = () => {
        setIsOpen((v) => !v)
    }

    return (
        <>
            <Tab
                ref={anchorEl}
                onClick={handleToggleOpen}
                sx={{
                    minWidth: 100,
                    maxWidth: 200,
                    flexGrow: 1,
                    flexShrink: 1,
                    padding: 1,
                }}
                label={
                    <>
                        {(!startDate || !endDate || !isSelected) && <CalendarMonthIcon />}
                        {startDate && endDate && isSelected && (
                            <span style={{ lineHeight: 1 }}>
                                {startDate.replace(/-/g, '\u2011')} - {endDate.replace(/-/g, '\u2011')}
                            </span>
                        )}
                    </>
                }
            />
            <Popover
                id={popoverId}
                open={isOpen}
                anchorEl={anchorEl.current}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{ vertical: 0, horizontal: 'right' }}
                onClose={handleToggleOpen}
            >
                <TradeGraphCustomDatesForm minDate={firstTradingDate} maxDate={lastTradingDate} />
            </Popover>
        </>
    )
}
